import FirstLogin from './FirstLogin';
import Login from './Login';
import NewPassword from './NewPassword';
import Recovery from './Recovery';

export default {
  FirstLogin, Login, NewPassword, Recovery,
};
